module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"excerpt":"Hello world.\n","frontmatter":{"title":"Hello World","path":"some-path","tags":["tag-1","tag-2","sample"]},"fields":{"slug":"/hello-world/"}}}]},"site":{"siteMetadata":{"title":"Chetan Arya's technology blog","facebook":{"appId":""}}}},"pathContext":{"tag":"sample"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-sample.json
// module id = 417
// module chunks = 36381688080178